import { render, staticRenderFns } from "./UploadTradesCSV.vue?vue&type=template&id=0bb1b35e"
import script from "./UploadTradesCSV.vue?vue&type=script&lang=js"
export * from "./UploadTradesCSV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports